export default __webpack_public_path__ + "static/media/preview.304e5846.jpg";